var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 237.46,
    height: 61.6142,
    viewBox: "0 0 237.46 61.6142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 94",
    x: 67.0114,
    y: 4.39781,
    width: 6.60256,
    height: 24.4972,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_0_5",
    maskUnits: "userSpaceOnUse",
    x: 70.2535,
    y: -0.266382,
    width: 84,
    height: 45,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 70.2535,
    y: -0.266382,
    width: 84,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6764 16.6242L80.5182 7.54026L77.2672 10.7639L86.5123 19.9328L71.0875 19.4905V24.1614L86.8941 23.717L77.651 32.885L80.901 36.1086L89.6764 27.4035V43.8225H94.4264V27.7844L102.817 36.1076L106.067 32.883L96.5543 23.4455L153.254 21.8547L96.9068 20.2326L106.452 10.7649L103.202 7.54026L94.4264 16.2444V0.733618H89.6764V16.6242Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.6764 16.6242L80.5182 7.54026L77.2672 10.7639L86.5123 19.9328L71.0875 19.4905V24.1614L86.8941 23.717L77.651 32.885L80.901 36.1086L89.6764 27.4035V43.8225H94.4264V27.7844L102.817 36.1076L106.067 32.883L96.5543 23.4455L153.254 21.8547L96.9068 20.2326L106.452 10.7649L103.202 7.54026L94.4264 16.2444V0.733618H89.6764V16.6242Z",
    fill: "url(#paint0_linear_0_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6764 16.6242H90.41C90.41 16.9204 90.2319 17.1875 89.9585 17.3014C89.6851 17.4153 89.37 17.3537 89.1597 17.1451L89.6764 16.6242ZM80.5182 7.54026L80.0016 7.01933C80.2876 6.73571 80.7488 6.73575 81.0348 7.01941L80.5182 7.54026ZM77.2672 10.7639L76.7506 11.2848C76.6117 11.147 76.5336 10.9595 76.5336 10.7639C76.5336 10.5682 76.6117 10.3807 76.7506 10.243L77.2672 10.7639ZM86.5123 19.9328L87.0289 19.4119C87.2427 19.624 87.3052 19.9451 87.1866 20.2219C87.0679 20.4986 86.7923 20.6748 86.4913 20.6662L86.5123 19.9328ZM71.0875 19.4905H70.3539C70.3539 19.2922 70.4341 19.1025 70.5762 18.9643C70.7184 18.8262 70.9104 18.7515 71.1085 18.7571L71.0875 19.4905ZM71.0875 24.1614L71.1081 24.8947C70.91 24.9002 70.7181 24.8255 70.5761 24.6873C70.434 24.5492 70.3539 24.3595 70.3539 24.1614H71.0875ZM86.8941 23.717L86.8735 22.9837C87.1744 22.9752 87.45 23.1514 87.5685 23.4282C87.687 23.7049 87.6245 24.0259 87.4108 24.2379L86.8941 23.717ZM77.651 32.885L77.1343 33.4058C76.9955 33.2681 76.9174 33.0806 76.9174 32.885C76.9174 32.6894 76.9955 32.5019 77.1343 32.3641L77.651 32.885ZM80.901 36.1086L81.4176 36.6294C81.1316 36.9132 80.6704 36.9132 80.3843 36.6295L80.901 36.1086ZM89.6764 27.4035L89.1597 26.8827C89.37 26.6741 89.6851 26.6124 89.9585 26.7263C90.2319 26.8402 90.41 27.1074 90.41 27.4035H89.6764ZM89.6764 43.8225V44.5561C89.2712 44.5561 88.9427 44.2277 88.9427 43.8225H89.6764ZM94.4264 43.8225H95.16C95.16 44.2277 94.8315 44.5561 94.4264 44.5561V43.8225ZM94.4264 27.7844H93.6927C93.6927 27.4882 93.8708 27.2211 94.1443 27.1072C94.4177 26.9933 94.7327 27.055 94.943 27.2636L94.4264 27.7844ZM102.817 36.1076L103.334 36.6284C103.048 36.9122 102.586 36.9122 102.3 36.6285L102.817 36.1076ZM106.067 32.883L106.584 32.3622C106.723 32.5 106.801 32.6874 106.801 32.883C106.801 33.0786 106.723 33.2661 106.584 33.4038L106.067 32.883ZM96.5543 23.4455L96.0376 23.9663C95.8292 23.7596 95.7641 23.4486 95.8721 23.1757C95.9801 22.9027 96.2403 22.7204 96.5337 22.7122L96.5543 23.4455ZM153.254 21.8547L153.275 21.1214C153.672 21.1328 153.987 21.4579 153.987 21.855C153.987 22.252 153.671 22.5769 153.274 22.588L153.254 21.8547ZM96.9068 20.2326L96.8857 20.966C96.5924 20.9575 96.3324 20.7751 96.2245 20.5022C96.1167 20.2293 96.1819 19.9184 96.3902 19.7118L96.9068 20.2326ZM106.452 10.7649L106.968 10.2441C107.107 10.3818 107.185 10.5693 107.185 10.7649C107.185 10.9605 107.107 11.148 106.968 11.2857L106.452 10.7649ZM103.202 7.54026L102.685 7.0194C102.971 6.73569 103.432 6.73573 103.718 7.01948L103.202 7.54026ZM94.4264 16.2444L94.943 16.7652C94.7327 16.9738 94.4176 17.0355 94.1442 16.9216C93.8708 16.8077 93.6927 16.5405 93.6927 16.2444H94.4264ZM94.4264 0.733618V1.88229e-08C94.8315 1.88229e-08 95.16 0.328452 95.16 0.733618L94.4264 0.733618ZM89.6764 0.733618H88.9427C88.9427 0.328452 89.2712 1.88229e-08 89.6764 1.88229e-08V0.733618ZM89.6764 16.6242L89.1597 17.1451L80.0015 8.06111L80.5182 7.54026L81.0348 7.01941L90.193 16.1034L89.6764 16.6242ZM80.5182 7.54026L81.0347 8.06119L77.7837 11.2848L77.2672 10.7639L76.7506 10.243L80.0016 7.01933L80.5182 7.54026ZM77.2672 10.7639L77.7838 10.243L87.0289 19.4119L86.5123 19.9328L85.9957 20.4537L76.7506 11.2848L77.2672 10.7639ZM86.5123 19.9328L86.4913 20.6662L71.0665 20.2238L71.0875 19.4905L71.1085 18.7571L86.5333 19.1995L86.5123 19.9328ZM71.0875 19.4905H71.8211V24.1614H71.0875H70.3539V19.4905H71.0875ZM71.0875 24.1614L71.0669 23.428L86.8735 22.9837L86.8941 23.717L86.9147 24.4503L71.1081 24.8947L71.0875 24.1614ZM86.8941 23.717L87.4108 24.2379L78.1676 33.4058L77.651 32.885L77.1343 32.3641L86.3775 23.1962L86.8941 23.717ZM77.651 32.885L78.1676 32.3641L81.4176 35.5878L80.901 36.1086L80.3843 36.6295L77.1343 33.4058L77.651 32.885ZM80.901 36.1086L80.3843 35.5878L89.1597 26.8827L89.6764 27.4035L90.193 27.9244L81.4176 36.6294L80.901 36.1086ZM89.6764 27.4035H90.41V43.8225H89.6764H88.9427V27.4035H89.6764ZM89.6764 43.8225V43.0889H94.4264V43.8225V44.5561H89.6764V43.8225ZM94.4264 43.8225H93.6927V27.7844H94.4264H95.16V43.8225H94.4264ZM94.4264 27.7844L94.943 27.2636L103.334 35.5868L102.817 36.1076L102.3 36.6285L93.9097 28.3052L94.4264 27.7844ZM102.817 36.1076L102.3 35.5869L105.55 32.3623L106.067 32.883L106.584 33.4038L103.334 36.6284L102.817 36.1076ZM106.067 32.883L105.55 33.4038L96.0376 23.9663L96.5543 23.4455L97.071 22.9247L106.584 32.3622L106.067 32.883ZM96.5543 23.4455L96.5337 22.7122L153.233 21.1214L153.254 21.8547L153.274 22.588L96.5749 24.1789L96.5543 23.4455ZM153.254 21.8547L153.232 22.588L96.8857 20.966L96.9068 20.2326L96.9279 19.4993L153.275 21.1214L153.254 21.8547ZM96.9068 20.2326L96.3902 19.7118L105.935 10.244L106.452 10.7649L106.968 11.2857L97.4235 20.7535L96.9068 20.2326ZM106.452 10.7649L105.935 11.2856L102.685 8.06103L103.202 7.54026L103.718 7.01948L106.968 10.2441L106.452 10.7649ZM103.202 7.54026L103.718 8.06112L94.943 16.7652L94.4264 16.2444L93.9097 15.7235L102.685 7.0194L103.202 7.54026ZM94.4264 16.2444H93.6927V0.733618H94.4264H95.16V16.2444H94.4264ZM94.4264 0.733618V1.46723H89.6764V0.733618V1.88229e-08H94.4264V0.733618ZM89.6764 0.733618H90.41V16.6242H89.6764H88.9427V0.733618H89.6764Z",
    fill: "url(#paint1_linear_0_5)",
    mask: "url(#path-2-outside-1_0_5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 84",
    x: 26.0209,
    y: 4.56195,
    width: 7.33268,
    height: 52.446,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 146",
    d: "M6.97121 4.42258H13.9638L6.99259 49.519H0L6.97121 4.42258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 101",
    x: 108.006,
    y: 4.39781,
    width: 7.33268,
    height: 52.6094,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 85",
    x: 30.9707,
    y: 12.7351,
    width: 6.111,
    height: 3.63853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 129",
    x: 71.2308,
    y: 12.7837,
    width: 6.111,
    height: 3.63853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 102",
    x: 82.015,
    y: 48.4422,
    width: 33.3235,
    height: 3.63853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 96",
    x: 40.006,
    y: 4.39781,
    width: 21.6765,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 97",
    x: 40.006,
    y: 15.2512,
    width: 22.3717,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 98",
    x: 40.006,
    y: 25.9847,
    width: 22.3717,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 99",
    x: 40.006,
    y: 15.2512,
    width: 7.33617,
    height: 13.6445,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100",
    x: 55.0417,
    y: 4.39781,
    width: 7.33617,
    height: 10.8527,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-outside-2_0_5",
    maskUnits: "userSpaceOnUse",
    x: 46.9696,
    y: 31.2173,
    width: 25,
    height: 31,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 46.9696,
    y: 31.2173,
    width: 25,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9696 46.4751C70.9696 54.3495 65.9665 60.7338 59.7948 60.7339C53.6231 60.7339 48.62 54.3496 48.62 46.4751C48.6201 38.6007 53.6231 32.2173 59.7948 32.2173C65.9664 32.2174 70.9695 38.6007 70.9696 46.4751ZM65.7509 46.2759C65.7508 40.145 63.1184 35.1754 59.871 35.1753C56.6235 35.1753 53.9911 40.145 53.9911 46.2759C53.9911 52.4068 56.6235 57.3774 59.871 57.3774C63.1184 57.3773 65.7509 52.4067 65.7509 46.2759Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.9696 46.4751C70.9696 54.3495 65.9665 60.7338 59.7948 60.7339C53.6231 60.7339 48.62 54.3496 48.62 46.4751C48.6201 38.6007 53.6231 32.2173 59.7948 32.2173C65.9664 32.2174 70.9695 38.6007 70.9696 46.4751ZM65.7509 46.2759C65.7508 40.145 63.1184 35.1754 59.871 35.1753C56.6235 35.1753 53.9911 40.145 53.9911 46.2759C53.9911 52.4068 56.6235 57.3774 59.871 57.3774C63.1184 57.3773 65.7509 52.4067 65.7509 46.2759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9696 46.4751H71.8499V46.4751L70.9696 46.4751ZM59.7948 60.7339V61.6142H59.7948L59.7948 60.7339ZM48.62 46.4751L47.7397 46.4751V46.4751H48.62ZM59.7948 32.2173L59.7948 31.3369H59.7948V32.2173ZM65.7509 46.2759H66.6312V46.2758L65.7509 46.2759ZM59.871 35.1753L59.871 34.2949H59.871V35.1753ZM53.9911 46.2759L53.1107 46.2758V46.2759H53.9911ZM59.871 57.3774V58.2578H59.871L59.871 57.3774ZM70.9696 46.4751H70.0893C70.0893 54.0752 65.2925 59.8534 59.7948 59.8535L59.7948 60.7339L59.7948 61.6142C66.6404 61.6141 71.8499 54.6238 71.8499 46.4751H70.9696ZM59.7948 60.7339V59.8535C54.297 59.8535 49.5003 54.0753 49.5003 46.4751H48.62H47.7397C47.7397 54.6239 52.9491 61.6142 59.7948 61.6142V60.7339ZM48.62 46.4751L49.5003 46.4751C49.5004 38.875 54.297 33.0976 59.7948 33.0976V32.2173V31.3369C52.9492 31.3369 47.7398 38.3263 47.7397 46.4751L48.62 46.4751ZM59.7948 32.2173L59.7948 33.0976C65.2925 33.0977 70.0892 38.8751 70.0893 46.4751L70.9696 46.4751L71.8499 46.4751C71.8498 38.3264 66.6403 31.337 59.7948 31.3369L59.7948 32.2173ZM65.7509 46.2759L66.6312 46.2758C66.6312 43.0961 65.9504 40.1738 64.8066 38.0145C63.6836 35.8944 61.9812 34.295 59.871 34.2949L59.871 35.1753L59.8709 36.0556C61.0082 36.0557 62.2456 36.9411 63.2507 38.8386C64.235 40.6969 64.8705 43.3248 64.8705 46.2759L65.7509 46.2759ZM59.871 35.1753V34.2949C57.7607 34.2949 56.0583 35.8943 54.9353 38.0144C53.7915 40.1737 53.1108 43.0961 53.1107 46.2758L53.9911 46.2759L54.8714 46.2759C54.8715 43.3247 55.5069 40.6968 56.4912 38.8385C57.4963 36.941 58.7337 36.0556 59.871 36.0556V35.1753ZM53.9911 46.2759H53.1107C53.1107 49.4557 53.7915 52.3782 54.9353 54.5378C56.0582 56.658 57.7606 58.2578 59.871 58.2578V57.3774V56.4971C58.7338 56.4971 57.4963 55.6115 56.4912 53.7137C55.5069 51.8552 54.8714 49.227 54.8714 46.2759H53.9911ZM59.871 57.3774L59.871 58.2578C61.9813 58.2577 63.6837 56.658 64.8067 54.5377C65.9504 52.3782 66.6312 49.4556 66.6312 46.2759H65.7509H64.8705C64.8705 49.227 64.2351 51.8552 63.2507 53.7136C62.2456 55.6114 61.0081 56.497 59.8709 56.4971L59.871 57.3774Z",
    fill: "white",
    mask: "url(#path-15-outside-2_0_5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtract_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-17-outside-3_0_5",
    maskUnits: "userSpaceOnUse",
    x: 7.70178,
    y: 14.889,
    width: 14,
    height: 35,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 7.70178,
    y: 14.889,
    width: 14,
    height: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7018 48.889C20.7018 44.6484 20.4132 40.2502 19.8541 36.3324C19.295 32.4145 18.4761 28.8544 17.443 25.8558C16.4099 22.8573 15.1834 20.4786 13.8336 18.8558C12.4839 17.233 11.0368 16.3978 9.57581 16.3978L9.57678 23.8871C9.74968 23.84 9.92297 23.8139 10.0973 23.8138C12.5948 24.1815 15.5055 31.9775 15.5055 45.683C15.5055 46.7694 15.4876 47.8394 15.4557 48.889H20.7018Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7018 48.889C20.7018 44.6484 20.4132 40.2502 19.8541 36.3324C19.295 32.4145 18.4761 28.8544 17.443 25.8558C16.4099 22.8573 15.1834 20.4786 13.8336 18.8558C12.4839 17.233 11.0368 16.3978 9.57581 16.3978L9.57678 23.8871C9.74968 23.84 9.92297 23.8139 10.0973 23.8138C12.5948 24.1815 15.5055 31.9775 15.5055 45.683C15.5055 46.7694 15.4876 47.8394 15.4557 48.889H20.7018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7018 48.889L21.5821 48.889L21.5821 49.7694H20.7018V48.889ZM19.8541 36.3324L20.7256 36.208H20.7256L19.8541 36.3324ZM17.443 25.8558L18.2753 25.5691L18.2753 25.5691L17.443 25.8558ZM13.8336 18.8558L14.5104 18.2929L14.5104 18.2929L13.8336 18.8558ZM9.57581 16.3978L8.69547 16.3979L8.69535 15.5175H9.57581V16.3978ZM9.57678 23.8871L9.80812 24.7365L8.69659 25.0392L8.69644 23.8872L9.57678 23.8871ZM10.0973 23.8138L10.0971 22.9335L10.1616 22.9335L10.2255 22.9429L10.0973 23.8138ZM15.5055 45.683H16.3858V45.683L15.5055 45.683ZM15.4557 48.889V49.7694H14.5482L14.5758 48.8622L15.4557 48.889ZM20.7018 48.889L19.8214 48.889C19.8214 44.6852 19.5352 40.3289 18.9826 36.4567L19.8541 36.3324L20.7256 36.208C21.2912 40.1715 21.5821 44.6115 21.5821 48.889L20.7018 48.889ZM19.8541 36.3324L18.9826 36.4567C18.4295 32.5811 17.6217 29.0773 16.6107 26.1426L17.443 25.8558L18.2753 25.5691C19.3304 28.6316 20.1605 32.2479 20.7256 36.208L19.8541 36.3324ZM17.443 25.8558L16.6107 26.1426C15.5966 23.1992 14.4132 20.9294 13.1568 19.4188L13.8336 18.8558L14.5104 18.2929C15.9535 20.0279 17.2233 22.5154 18.2753 25.5691L17.443 25.8558ZM13.8336 18.8558L13.1568 19.4188C11.8975 17.9047 10.6751 17.2781 9.57581 17.2781V16.3978V15.5175C11.3985 15.5175 13.0702 16.5613 14.5104 18.2929L13.8336 18.8558ZM9.57581 16.3978L10.4561 16.3977L10.4571 23.887L9.57678 23.8871L8.69644 23.8872L8.69547 16.3979L9.57581 16.3978ZM9.57678 23.8871L9.34544 23.0377C9.58283 22.973 9.8342 22.9335 10.0971 22.9335L10.0973 23.8138L10.0975 24.6942C10.0117 24.6942 9.91653 24.7069 9.80812 24.7365L9.57678 23.8871ZM10.0973 23.8138L10.2255 22.9429C11.2507 23.0938 12.0857 23.9431 12.7421 24.9914C13.4269 26.0852 14.053 27.6096 14.5856 29.509C15.6531 33.3158 16.3858 38.7755 16.3858 45.683H15.5055H14.6252C14.6252 38.885 13.9025 33.5939 12.8903 29.9844C12.3831 28.1756 11.8132 26.8256 11.2498 25.9258C10.658 24.9807 10.1926 24.7177 9.96909 24.6848L10.0973 23.8138ZM15.5055 45.683L16.3858 45.683C16.3858 46.779 16.3678 47.858 16.3356 48.9158L15.4557 48.889L14.5758 48.8622C14.6074 47.8209 14.6252 46.7598 14.6252 45.683L15.5055 45.683ZM15.4557 48.889V48.0087H20.7018V48.889V49.7694H15.4557V48.889Z",
    fill: "white",
    mask: "url(#path-17-outside-3_0_5)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 107",
    x: 147.749,
    y: 4.39781,
    width: 7.33268,
    height: 52.6094,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 113",
    x: 187.612,
    y: 4.39781,
    width: 7.33268,
    height: 52.7523,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 108",
    x: 152.699,
    y: 12.7585,
    width: 6.111,
    height: 3.63853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 114",
    x: 192.549,
    y: 12.7585,
    width: 6.111,
    height: 3.63853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120",
    x: 202.025,
    y: 36.7604,
    width: 3.63853,
    height: 29.9862,
    transform: "rotate(-90 202.025 36.7604)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 121",
    x: 213.365,
    y: 33.1215,
    width: 5.82164,
    height: 7.33617,
    transform: "rotate(-90 213.365 33.1215)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 115",
    x: 161.616,
    y: 4.39781,
    width: 20.6599,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 133",
    x: 121.758,
    y: 4.56487,
    width: 20.6599,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 110",
    x: 121.758,
    y: 45.9796,
    width: 22.0802,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 116",
    x: 161.616,
    y: 45.9796,
    width: 21.3848,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 119",
    x: 161.616,
    y: 25.1882,
    width: 21.3848,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 138",
    x: 202.025,
    y: 22.2778,
    width: 30.0009,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 139",
    x: 202.025,
    y: 4.39781,
    width: 30.0009,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 140",
    x: 202.032,
    y: 13.3368,
    width: 30.0009,
    height: 2.91082,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 90",
    x: 202.025,
    y: 53.369,
    width: 30.0083,
    height: 3.63853,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 89",
    x: 202.025,
    y: 5.95378,
    width: 7.33617,
    height: 19.2345,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 111",
    x: 121.758,
    y: 5.93727,
    width: 7.33617,
    height: 42.9524,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 117",
    x: 161.616,
    y: 25.1882,
    width: 7.33617,
    height: 23.7012,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 112",
    x: 136.502,
    y: 4.56487,
    width: 7.33617,
    height: 42.6006,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118",
    x: 176.36,
    y: 4.39781,
    width: 7.33617,
    height: 23.7009,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 91",
    x: 202.025,
    y: 38.8884,
    width: 7.33617,
    height: 15.2818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-outside-4_0_5",
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 23.5763,
    width: 53,
    height: 29,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 185,
    y: 23.5763,
    width: 53,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.139 34.5392L191.396 28.8439L189.358 30.8654L195.155 36.6144L185.484 36.3371V39.2648L195.396 38.9855L189.599 44.7355L191.637 46.757L197.139 41.299V51.5919H200.116V41.5353L205.378 46.755L207.415 44.7335L201.45 38.8156L237 37.8185L201.673 36.8009L207.656 30.8664L205.618 28.8449L200.116 34.3019V24.5763H197.139V34.5392Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.139 34.5392L191.396 28.8439L189.358 30.8654L195.155 36.6144L185.484 36.3371V39.2648L195.396 38.9855L189.599 44.7355L191.637 46.757L197.139 41.299V51.5919H200.116V41.5353L205.378 46.755L207.415 44.7335L201.45 38.8156L237 37.8185L201.673 36.8009L207.656 30.8664L205.618 28.8449L200.116 34.3019V24.5763H197.139V34.5392Z",
    fill: "url(#paint2_linear_0_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.139 34.5392H197.599C197.599 34.7249 197.487 34.8924 197.316 34.9638C197.144 35.0352 196.947 34.9965 196.815 34.8658L197.139 34.5392ZM191.396 28.8439L191.073 28.5173C191.252 28.3395 191.541 28.3395 191.72 28.5173L191.396 28.8439ZM189.358 30.8654L189.035 31.192C188.947 31.1056 188.898 30.988 188.898 30.8654C188.898 30.7428 188.947 30.6252 189.034 30.5388L189.358 30.8654ZM195.155 36.6144L195.479 36.2878C195.613 36.4208 195.652 36.6221 195.578 36.7956C195.504 36.9691 195.331 37.0796 195.142 37.0742L195.155 36.6144ZM185.484 36.3371H185.024C185.024 36.2128 185.075 36.0938 185.164 36.0072C185.253 35.9206 185.373 35.8737 185.498 35.8773L185.484 36.3371ZM185.484 39.2648L185.497 39.7246C185.373 39.7281 185.253 39.6812 185.164 39.5946C185.075 39.508 185.024 39.389 185.024 39.2648H185.484ZM195.396 38.9855L195.383 38.5257C195.571 38.5204 195.744 38.6309 195.818 38.8044C195.893 38.9779 195.853 39.1791 195.719 39.3121L195.396 38.9855ZM189.599 44.7355L189.275 45.0621C189.188 44.9757 189.139 44.8581 189.139 44.7355C189.139 44.6129 189.188 44.4953 189.275 44.4089L189.599 44.7355ZM191.637 46.757L191.961 47.0835C191.781 47.2614 191.492 47.2614 191.313 47.0836L191.637 46.757ZM197.139 41.299L196.815 40.9724C196.947 40.8417 197.144 40.803 197.316 40.8744C197.487 40.9458 197.599 41.1133 197.599 41.299H197.139ZM197.139 51.5919V52.0519C196.885 52.0519 196.679 51.846 196.679 51.5919H197.139ZM200.116 51.5919H200.576C200.576 51.846 200.37 52.0519 200.116 52.0519V51.5919ZM200.116 41.5353H199.656C199.656 41.3496 199.768 41.1821 199.939 41.1107C200.111 41.0393 200.308 41.078 200.44 41.2088L200.116 41.5353ZM205.378 46.755L205.702 47.0815C205.523 47.2595 205.233 47.2595 205.054 47.0816L205.378 46.755ZM207.415 44.7335L207.739 44.407C207.826 44.4934 207.875 44.6109 207.875 44.7335C207.875 44.8561 207.826 44.9737 207.739 45.06L207.415 44.7335ZM201.45 38.8156L201.126 39.1421C200.996 39.0125 200.955 38.8175 201.022 38.6464C201.09 38.4753 201.253 38.361 201.437 38.3558L201.45 38.8156ZM237 37.8185L237.013 37.3587C237.262 37.3659 237.46 37.5697 237.46 37.8187C237.46 38.0676 237.262 38.2713 237.013 38.2783L237 37.8185ZM201.673 36.8009L201.66 37.2607C201.476 37.2554 201.313 37.141 201.245 36.9699C201.177 36.7988 201.218 36.6039 201.349 36.4744L201.673 36.8009ZM207.656 30.8664L207.98 30.5398C208.067 30.6262 208.116 30.7437 208.116 30.8664C208.116 30.989 208.067 31.1066 207.98 31.1929L207.656 30.8664ZM205.618 28.8449L205.294 28.5183C205.474 28.3405 205.763 28.3405 205.942 28.5183L205.618 28.8449ZM200.116 34.3019L200.44 34.6285C200.308 34.7592 200.111 34.7979 199.939 34.7265C199.768 34.6551 199.656 34.4876 199.656 34.3019H200.116ZM200.116 24.5763V24.1164C200.37 24.1164 200.576 24.3223 200.576 24.5763H200.116ZM197.139 24.5763H196.679C196.679 24.3223 196.885 24.1164 197.139 24.1164V24.5763ZM197.139 34.5392L196.815 34.8658L191.073 29.1705L191.396 28.8439L191.72 28.5173L197.463 34.2126L197.139 34.5392ZM191.396 28.8439L191.72 29.1705L189.682 31.192L189.358 30.8654L189.034 30.5388L191.073 28.5173L191.396 28.8439ZM189.358 30.8654L189.682 30.5388L195.479 36.2878L195.155 36.6144L194.831 36.941L189.035 31.192L189.358 30.8654ZM195.155 36.6144L195.142 37.0742L185.471 36.7968L185.484 36.3371L185.498 35.8773L195.168 36.1546L195.155 36.6144ZM185.484 36.3371H185.944V39.2648H185.484H185.024V36.3371H185.484ZM185.484 39.2648L185.471 38.805L195.383 38.5257L195.396 38.9855L195.408 39.4453L185.497 39.7246L185.484 39.2648ZM195.396 38.9855L195.719 39.3121L189.923 45.0621L189.599 44.7355L189.275 44.4089L195.072 38.6589L195.396 38.9855ZM189.599 44.7355L189.923 44.4089L191.961 46.4304L191.637 46.757L191.313 47.0836L189.275 45.0621L189.599 44.7355ZM191.637 46.757L191.313 46.4304L196.815 40.9724L197.139 41.299L197.463 41.6255L191.961 47.0835L191.637 46.757ZM197.139 41.299H197.599V51.5919H197.139H196.679V41.299H197.139ZM197.139 51.5919V51.132H200.116V51.5919V52.0519H197.139V51.5919ZM200.116 51.5919H199.656V41.5353H200.116H200.576V51.5919H200.116ZM200.116 41.5353L200.44 41.2088L205.702 46.4285L205.378 46.755L205.054 47.0816L199.792 41.8618L200.116 41.5353ZM205.378 46.755L205.054 46.4285L207.091 44.4071L207.415 44.7335L207.739 45.06L205.702 47.0815L205.378 46.755ZM207.415 44.7335L207.091 45.0601L201.126 39.1421L201.45 38.8156L201.774 38.4891L207.739 44.407L207.415 44.7335ZM201.45 38.8156L201.437 38.3558L236.987 37.3587L237 37.8185L237.013 38.2783L201.463 39.2754L201.45 38.8156ZM237 37.8185L236.987 38.2783L201.66 37.2607L201.673 36.8009L201.686 36.3412L237.013 37.3587L237 37.8185ZM201.673 36.8009L201.349 36.4744L207.332 30.5398L207.656 30.8664L207.98 31.1929L201.997 37.1275L201.673 36.8009ZM207.656 30.8664L207.332 31.1929L205.294 29.1714L205.618 28.8449L205.942 28.5183L207.98 30.5398L207.656 30.8664ZM205.618 28.8449L205.942 29.1714L200.44 34.6285L200.116 34.3019L199.792 33.9753L205.294 28.5183L205.618 28.8449ZM200.116 34.3019H199.656V24.5763H200.116H200.576V34.3019H200.116ZM200.116 24.5763V25.0363H197.139V24.5763V24.1164H200.116V24.5763ZM197.139 24.5763H197.599V34.5392H197.139H196.679V24.5763H197.139Z",
    fill: "url(#paint3_linear_0_5)",
    mask: "url(#path-40-outside-4_0_5)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5",
    x1: 85.3443,
    y1: 20.8718,
    x2: 127.808,
    y2: 25.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5170FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_5",
    x1: 85.3443,
    y1: 20.8718,
    x2: 127.808,
    y2: 25.5982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5170FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_5",
    x1: 194.423,
    y1: 37.2025,
    x2: 221.047,
    y2: 40.1658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_5",
    x1: 194.423,
    y1: 37.2025,
    x2: 221.047,
    y2: 40.1658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E0F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.d16c3951cd86694b6cb7065504540d5e.svg";
export { ForwardRef as ReactComponent };